import { GlobalStore, ZustandAPI } from './globalStore';

type Video = {
  duration: number;
};

export type VideoStore = {
  video: Video;
  setVideo: (video: Video) => void;
};

export const videoStore = (args: ZustandAPI): VideoStore => {
  const { set, get } = args;
  const video = initializeState(get);

  return {
    video: video,
    setVideo: (video: Video) => set(() => ({ video })),
  };
};

const initializeState = (get: () => GlobalStore): Video => {
  const lead = get()?.video;
  if (lead) {
    return lead;
  }
  return {
    duration: 0,
  };
};
